import dayjs from 'dayjs'
import { FirebaseError } from 'firebase/app'
import {
  createUserWithEmailAndPassword,
  // getAuth,
  sendEmailVerification,
} from 'firebase/auth'
import { doc, setDoc, updateDoc, getDoc, Timestamp } from 'firebase/firestore'
// import { getFunctions, httpsCallable } from 'firebase/functions'

import { auth, firestore } from './firebaseConfig'
import { updateAList } from './utils/lists'
import { AnyProfile, NewUser } from '../types'
import { convertToRoles } from '../utilFunctions'
import { handleErrors } from '../utilFunctions/firebaseErrors'

// const getSecondaryAuth = () => {
//   // OJO: el nombre "Secondary" debe ser único por app
//   const secondaryApp = initializeApp(firebaseConfig, 'SecondaryAuthApp')
//   return getAuth(secondaryApp)
// }

// Función reutilizable para crear un nuevo usuario
export const createUser = async (
  userData: AnyProfile,
  role: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resetState?: () => void,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalData?: any,
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { password, confirmPassword, uid, ...restUserData } =
    userData as NewUser

  const _role = convertToRoles(role)

  // que no envie el confirmPassword a la BD
  try {
    // const secondaryAuth = getSecondaryAuth()

    const userCredential = await createUserWithEmailAndPassword(
      // secondaryAuth,
      auth,
      userData.email,
      password,
    )

    const newUid = userCredential.user.uid

    const userDocRef = doc(firestore, _role, newUid)
    const userDoc = await getDoc(userDocRef)

    if (!userDoc.exists()) {
      await sendEmailVerification(userCredential.user)
      await setDoc(userDocRef, {
        ...restUserData,
        uid: userCredential.user.uid,
        image: userCredential.user.photoURL || '',
        ...additionalData, // Datos adicionales si se requieren
      })

      // Actualizar la lista de profesores si es necesario
      if (_role === 'professors') {
        const professorData = {
          name: `${userData.name} ${userData.lastname}`,
          uid: userCredential.user.uid,
        }
        await updateAList('professorsNames', professorData, 'professors')
      }

      // Si role == admin => setear claim admin (seguridad real)
      // if (role === 'admin') {
      //   const functions = getFunctions()
      //   const setAdminClaim = httpsCallable(functions, 'setAdminClaim')

      //   // IMPORTANTE: esta llamada debe hacerse logueada como un admin real (claim)
      //   await setAdminClaim({ uid: newUid, admin: true })
      // }
    }

    resetState && resetState()

    // cerrar sesión secundaria (limpieza)
    // await secondaryAuth.signOut()

    return null
  } catch (error) {
    console.log(error, 'createUser error')

    const fbError = error as FirebaseError
    return handleErrors(fbError.code) || fbError.message
    // setError(handleErrors(error))
  }
  // finally {
  //   setIsLoading(false)
  // }
}

export const updateStudentLoginLog = async (uid: string) => {
  const userDocRef = doc(firestore, 'students', uid)
  const userSnap = await getDoc(userDocRef)

  if (!userSnap.exists()) return
  const now = dayjs()
  const currentMonth = now.month()
  const currentYear = now.year()
  const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1
  const prevMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear

  const existingLogins: Timestamp[] = userSnap.data().logins || []
  const filtered = existingLogins.filter((ts) => {
    const date = dayjs(ts.toDate())
    const m = date.month()
    const y = date.year()
    return (
      (m === currentMonth && y === currentYear) ||
      (m === prevMonth && y === prevMonthYear)
    )
  })

  await updateDoc(userDocRef, {
    logins: [...filtered, Timestamp.now()],
  })
}
